import React, { useEffect } from "react";
import { NavLink, Outlet } from "react-router-dom";
import feather from 'feather-icons';

export default function RootRoute({ children }: any) {

  useEffect(() => {
    feather.replace();
  }, [])

  return (
    <div className="h-screen w-full border-b-2 border-black ">
      <div className="navbar flex justify-between bg-slate-400">
        <div className="">
          <p className="btn btn-ghost text-2xl">Project X</p>
        </div>

        <div className="navButtons">
          <NavLink
            to="/today"
            className={({ isActive, isPending }) =>
              isActive ? "text-blue-600 font-bold" : ""
            }
          >
            <span className="btn btn-ghost text-lg flex items-center justify-center">
              Today
              <i data-feather="target"></i>
            </span>
          </NavLink>

          <div className="divider divider-horizontal"></div>
          <NavLink 
            to="browsechallenges" 
            className={({ isActive, isPending }) =>
              isActive ? "text-blue-600 font-bold" : ""
            }
          >
            <span className="btn btn-ghost text-lg">
              Browse Challenges
              <i data-feather="globe"></i>
            </span>
          </NavLink>

          <div className="divider divider-horizontal"></div>
          <NavLink 
            to="myarcs" 
            className={({ isActive, isPending }) =>
              isActive ? "text-blue-600 font-bold" : ""
            }
          >
            <span className="btn btn-ghost text-lg">
              My Challenges
              <i data-feather="award"></i>
            </span>
          </NavLink>
        </div>

        <i data-feather="user" className="pointer h-2/6"></i>
      </div>
      <Outlet />
    </div>
  );
}
